export enum transferStatus {
  processing = "processing",
  successful = "successful",
  failed = "failed",
}
